<template>
  <div class="project-cont">
    <h2>{{ tit }}</h2>
    <h4>{{ subheading }}</h4>
    <div class="line"><span>&nbsp;</span></div>
    <div class="dec">
      <span>
        {{ msg }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectCont",
  data() {
    return {
      // title:''
    };
  },
  props: {
    tit: String,
    msg: String,
    subheading: String,
  },
};
</script>

<style lang="less">
.project-cont {
  h2 {
    font-size: 32px;
    margin-bottom: 20px;
  }

  h4 {
    font-size: 18px;
  }

  .line {
    margin: 30px 0;

    span {
      display: inline-block;
      width: 26px;
      height: 2px;
      background-color: #468bfe;
      line-height: 2px;
    }
  }

  .dec {
    text-align: left;
    fong-size: 14px;

    span {
      display: inline-block;
      line-height: 2;
      white-space: pre-wrap; /*这是重点。文本换行*/
    }
  }
}

.appoint-box {
  width: 100%;
  margin-top: 50px;
}
</style>
